import { createApp , ref } from 'vue/dist/vue.esm-bundler';
import { createPinia } from "pinia";
import { useContextStore } from './contextStore.js'
function initBasketReactive(){

    const el = document.querySelector( '#header-basket' );
    if( el ){
        createApp(
            {
                setup(){

                    const contextStore = useContextStore();

                    function getBasket(){
                        return contextStore.getBasket();
                    }

                    return {
                        contextStore ,
                        getBasket
                    }
                }
            }
        )
            .use( createPinia() )
            .mount( el )
    }


}

document.addEventListener( "DOMContentLoaded" , initBasketReactive );
